export const inventoryLookupFieldDropdown =  [
	{
	  title: "Product Name (SKU)",
	  value: "productName"
	},
	{
	  title: "Product Description",
	  value: "productDescription"
	},
	{
	  title: "Product UPC",
	  value: "productUpc"
	},
	{
	  title: "Variant Attribute Type",
	  value: "variantAttributeType"
	},
	{
	  title: "Variant Attribute Value",
	  value: "variantAttributeValue"
	}
]


// WEBPACK FOOTER //
// ./src/pages/inventory/lookup/filter/inventoryLookupFieldDropdown.js